import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import updateLogEvent from 'api/updateLogEvent';
import {updateObject} from 'utils/reducerUtils';
import create from 'assets/create-24px.svg';

import getAgeLabel from 'utils/getAgeLabel';
import getBatchedTestResults, {
	getBestTestResultMoment,
} from 'utils/getBatchedTestResults';
import roundWithDecimals from 'utils/roundWithDecimals';

import {
	GENDER_LABELS,
	LETTER_KNOWLEDGE,
	MINUTE,
	NONWORD_REPETITION,
	ORDDIKTAT,
	ORDKJEDETESTEN,
	PHONEME_DELETION,
	PHONEME_ISOLATION,
	RAPID_NOMINATION,
	SENTENCE_MEMORY,
	SKRIVEHASTIGHET,
	SPOONERISM,
	TULLEORDTESTEN,
	WORKING_MEMORY,
	WORKING_MEMORY_NUMBERS,
	WORKING_MEMORY_WORDS,
	LESEPRØVEN,
	ORDFORSTÅELSE,
	SPRAKFORSTÅELSE,
} from 'constants/index';

import './styles.scss';
import strings from 'utils/strings';
import getTestsBySearch from 'api/getTestsBySearch';
import getTestResultPath from 'utils/getTestResultPath';
import EditCandidateInfoModal from './editCandidateInfoModal';
import ToggleSwitch from 'components/Switch';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faMarker,
	faTrash,
	faTruckArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import EditTestResultOverview from './editTestResultOverview';
import TransferSubTestModel from './transferSubTestModel';
import DeleteSubTestModel from './deleteSubTestModel';
import MarkTestConfirmation from './markTestConfirmation';

const defaultFilters = {
	testKey: '',
};
const CHILD_TEST_STEPS_BY_ID = {
	0: {
		name: WORKING_MEMORY,
	},
	1: {
		name: WORKING_MEMORY_NUMBERS,
	},
	2: {
		name: WORKING_MEMORY_WORDS,
	},
	3: {
		name: RAPID_NOMINATION,
	},
	4: {
		name: MINUTE,
	},
	5: {
		name: SPOONERISM,
	},
	6: {
		name: LETTER_KNOWLEDGE,
	},
	7: {
		name: PHONEME_ISOLATION,
	},
	8: {
		name: PHONEME_DELETION,
	},
	9: {
		name: ORDDIKTAT,
	},
	10: {
		name: SENTENCE_MEMORY,
	},
	12: {
		name: MINUTE,
	},
	13: {
		name: NONWORD_REPETITION,
	},
};
const TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
	},
	2: {
		name: ORDKJEDETESTEN,
	},
	3: {
		name: TULLEORDTESTEN,
	},
	4: {
		name: SKRIVEHASTIGHET,
	},
	5: {
		name: LESEPRØVEN,
	},
	6: {
		name: ORDFORSTÅELSE,
	},
	7: {
		name: SPRAKFORSTÅELSE,
	},
};
class SearchByTestKey extends React.Component {
	constructor() {
		super();

		this.state = {
			filters: defaultFilters,
			batchedTestResults: [],
			isSearchButtonClicked: false,
			isEditCandidateInfoButtonClicked: false,
			isSwitchOn: false,
			selectedIds: [],
			isEditTestResultOverviewButtonClicked: false,
			selectedIdObject: null,
			isTransferSubTestButtonClicked: false,
			isSubTestDeleteButtonClicked: false,
			isMarkTestButtonClicked: false,
		};
		this.handleClick = this.handleClick.bind(this);
		this.handleSubmitTestKey = this.handleSubmitTestKey.bind(this);
		this.handleEditCandidateInfo = this.handleEditCandidateInfo.bind(this);
		this.toggleSwitch = this.toggleSwitch.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
		this.handleEditTestResultOverview =
			this.handleEditTestResultOverview.bind(this);
		this.onEditTestResultOverviewModelConfirm =
			this.onEditTestResultOverviewModelConfirm.bind(this);
		this.onTransferSubTestModelConfirm =
			this.onTransferSubTestModelConfirm.bind(this);
		this.handleTransferSubTest = this.handleTransferSubTest.bind(this);
		this.onSubTestDeleteModelConfirm =
			this.onSubTestDeleteModelConfirm.bind(this);
		this.handleSubTestDelete = this.handleSubTestDelete.bind(this);
		this.handleMarkTest = this.handleMarkTest.bind(this);
		this.onMarkTestModelConfirm = this.onMarkTestModelConfirm.bind(this);
	}

	handleClick = (id, key) => {
		this.updateViewLog(id, key);
	};

	updateViewLog(id, key) {
		updateLogEvent('view', id, key, 'Results');
	}

	handleSubmitTestKey() {
		getTestsBySearch(this.state.filters).then((testResults) => {
			this.setState({
				batchedTestResults: testResults,
				isSearchButtonClicked: true,
			});
		});
	}
	handleEditCandidateInfo = () => {
		this.setState({
			isEditCandidateInfoButtonClicked: true,
		});
	};

	onEditModelConfirm = () => {
		this.setState({
			isEditCandidateInfoButtonClicked: false,
		});
	};
	handleEditTestResultOverview = (id) => {
		const selectedObject =
			Array.isArray(this.state.batchedTestResults) &&
			this.state.batchedTestResults.length > 0 &&
			Array.isArray(this.state.batchedTestResults[0].resultsOverview)
				? this.state.batchedTestResults[0].resultsOverview.filter(
						(item) => item.id === id
				  )
				: [];
		this.setState({
			isEditTestResultOverviewButtonClicked: true,
			selectedIdObject: selectedObject,
		});
	};

	onEditTestResultOverviewModelConfirm = () => {
		this.setState({
			isEditTestResultOverviewButtonClicked: false,
		});
	};

	handleTransferSubTest = () => {
		this.setState({
			isTransferSubTestButtonClicked: true,
		});
	};

	handleMarkTest = () => {
		this.setState({
			isMarkTestButtonClicked: true,
		});
	};

	onMarkTestModelConfirm = () => {
		this.setState({
			isMarkTestButtonClicked: false,
		});
	};
	onTransferSubTestModelConfirm = () => {
		this.setState({
			isTransferSubTestButtonClicked: false,
		});
	};
	onSubTestDeleteModelConfirm = () => {
		this.setState({
			isSubTestDeleteButtonClicked: false,
		});
	};
	handleSubTestDelete = (id) => {
		const selectedObject =
			Array.isArray(this.state.batchedTestResults) &&
			this.state.batchedTestResults.length > 0 &&
			Array.isArray(this.state.batchedTestResults[0].resultsOverview)
				? this.state.batchedTestResults[0].resultsOverview.filter(
						(item) => item.id === id
				  )
				: [];
		this.setState({
			isSubTestDeleteButtonClicked: true,
			selectedIdObject: selectedObject,
		});
	};
	toggleSwitch = () => {
		this.setState((prevState) => ({
			isSwitchOn: !prevState.isSwitchOn,
		}));
	};
	handleCheckbox = (id) => {
		this.setState((prev) => {
			const alreadySelected = prev.selectedIds.includes(id);

			// If selected → remove it
			if (alreadySelected) {
				return {
					selectedIds: prev.selectedIds.filter((item) => item !== id),
				};
			}

			// If not selected → add it
			return {
				selectedIds: [...prev.selectedIds, id],
			};
		});
	};
	render() {
		const {
			filters,
			batchedTestResults,
			isSearchButtonClicked,
			isEditCandidateInfoButtonClicked,
			isSwitchOn,
			selectedIds,
			isEditTestResultOverviewButtonClicked,
			selectedIdObject,
			isTransferSubTestButtonClicked,
			isSubTestDeleteButtonClicked,
			isMarkTestButtonClicked,
		} = this.state;
		const months = batchedTestResults;
		const testKeyType =
			Array.isArray(months) &&
			months.length > 0 &&
			months[0] &&
			months[0].type
				? months[0].type
				: null;
		const isTestCompleted =
			Array.isArray(months) &&
			months.length > 0 &&
			months[0] &&
			months[0].completedAt
				? months[0].completedAt
				: null;
		const isTestUsed =
			Array.isArray(months) &&
			months.length > 0 &&
			months[0] &&
			months[0].isUsed
				? months[0].isUsed
				: null;
		return (
			<div className="lit-all-tests">
				<form
					onSubmit={(event) => {
						event.preventDefault();
						this.handleSubmitTestKey();
					}}
				>
					<div className="lit-filters-row">
						<div className="lit-filters">
							<h4 className="lit-filters__heading">
								{strings.testkey}
							</h4>
							<input
								className="lit_txtf"
								type="text"
								placeholder={strings.enterTestKeyPlaceholder}
								id="testKey"
								required
								name="testKey"
								onChange={(event) => {
									const value = event.target.value;
									// eslint-disable-next-line no-undefined
									if (value === '') {
										this.setState({
											filters: defaultFilters,
										});
									} else {
										const newFilters = updateObject(
											filters,
											{
												testKey: value,
											}
										);
										this.setState({
											filters: newFilters,
										});
									}
								}}
								value={filters.testKey}
							/>
						</div>
					</div>

					<button
						className="lit-btn lit-btn--small bg-primary"
						type="submit"
					>
						{strings.searchhere}
					</button>
				</form>
				{months.length === 0 && isSearchButtonClicked && (
					<p>{strings.notetsfound}</p>
				)}
				{Boolean(months.length) && (
					<>
						<div className="month">
							<table className="lit-list">
								<thead>
									<tr>
										<th>{strings.testdate}</th>
										<th>{strings.test_type}</th>
										<th>{strings.zscore}</th>
										<th>{strings.testkey}</th>
										<th>{strings.sex}</th>
										<th>{strings.age}</th>
										<th>{strings.actions}</th>
									</tr>
								</thead>
								<tbody>
									{months.map((testResult) => {
										const {
											id,
											zScore,
											key,
											type,
											testVersion,
											isUsed,
											testUser: {gender, age},
										} = testResult;
										const time =
											getBestTestResultMoment(testResult);
										return (
											<tr
												className="lit-list__item"
												key={id}
											>
												<td className={classNames({})}>
													{moment(time).format('LL')}
												</td>
												<td className={classNames({})}>
													{type}
												</td>
												<td className={classNames({})}>
													<h3 className="score">
														{roundWithDecimals(
															zScore,
															3
														)}
													</h3>
												</td>
												<td>{key}</td>
												<td>
													{gender
														? GENDER_LABELS[gender]
														: '--'}
												</td>
												<td>
													{age && age.years
														? getAgeLabel(age)
														: '--'}
												</td>
												{Boolean(isUsed) && (
													<>
														<td>
															<Link
																className="lit-btn lit-btn--small bg-secondary"
																target="_blank"
																rel="noopener noreferrer"
																to={getTestResultPath(
																	type,
																	id,
																	testVersion
																)}
																onClick={() =>
																	this.handleClick(
																		id,
																		key
																	)
																}
															>
																{
																	strings.seeresults
																}
															</Link>
															<button
																className="lit-btn lit-btn--small bg-primary"
																onClick={() =>
																	this.handleEditCandidateInfo()
																}
																style={{
																	height: '37px',
																}}
															>
																{
																	<img
																		src={
																			create
																		}
																		alt=""
																	/>
																}
															</button>
														</td>
													</>
												)}
												{Boolean(!isUsed) && (
													<td>
														<span
															style={{
																color: 'red',
																fontWeight:
																	'bold',
															}}
														>
															{strings.notUsed}
														</span>
													</td>
												)}
											</tr>
										);
									})}
								</tbody>
							</table>
							{isEditCandidateInfoButtonClicked && (
								<EditCandidateInfoModal
									onConfirm={this.onEditModelConfirm}
									onCancel={this.onEditModelConfirm}
									selectedTestUser={months}
									getTestsBySearch={this.handleSubmitTestKey}
								/>
							)}
						</div>
						{Boolean(isTestUsed) && (
							<div className="lit-icon-btns-div">
								{strings.seeOverview} &nbsp;{' '}
								<ToggleSwitch
									isSwitchOn={isSwitchOn}
									toggleSwitch={this.toggleSwitch}
								/>
								{isSwitchOn && (
									<>
										<div>
											<button
												className="lit-mytests-header-mytest-btn-secondary"
												onClick={() => {
													this.handleTransferSubTest();
												}}
												disabled={
													selectedIds.length <= 0
												}
											>
												<FontAwesomeIcon
													className="lit-icon-btns"
													icon={faTruckArrowRight}
												/>
												<p className="lit-btns-txt">
													{strings.transferTest}
												</p>
											</button>
										</div>
										<div>
											<button
												className="lit-mytests-header-mytest-btn-ternary"
												onClick={() => {
													this.handleMarkTest();
												}}
											>
												<FontAwesomeIcon
													className="lit-icon-btns"
													icon={faMarker}
												/>
												<p className="lit-btns-txt">
													{isTestCompleted
														? strings.markTestAsIncomplete
														: strings.markTestAsComplete}
												</p>
											</button>
										</div>
									</>
								)}
							</div>
						)}
						{isSwitchOn && (
							<div className="table-scroll-container">
								<table className="lit-list">
									<thead>
										<tr>
											<th />
											<th>{strings.createdAt}</th>
											<th>{strings.testName}</th>
											<th>{strings.totalCorrectCount}</th>
											<th>{strings.actions}</th>
										</tr>
									</thead>
									<tbody>
										{months[0].resultsOverview.map(
											(overview) => {
												const {id, test, totalCorrect} =
													overview;
												const time =
													getBestTestResultMoment(
														overview
													);
												return (
													<tr
														className="lit-list__item"
														key={id}
													>
														<td>
															<div className="checkbox-wrapper-13">
																<input
																	className="user_checkbox2"
																	type="checkbox"
																	id="myCheck"
																	checked={selectedIds.includes(
																		id
																	)}
																	onChange={() =>
																		this.handleCheckbox(
																			id
																		)
																	}
																/>
															</div>
														</td>
														<td
															className={classNames(
																{}
															)}
														>
															{moment(
																time
															).format('LLL:ss')}
														</td>
														<td
															className={classNames(
																{}
															)}
														>
															{testKeyType.includes(
																'followup'
															) &&
																CHILD_TEST_STEPS_BY_ID[
																	test
																]?.name}

															{testKeyType.includes(
																'screening'
															) &&
																TEST_STEPS_BY_ID[
																	test
																]?.name}

															{!testKeyType.includes(
																'followup'
															) &&
																!testKeyType.includes(
																	'screening'
																) &&
																test}
														</td>

														<td>{totalCorrect}</td>
														<>
															<td>
																<button
																	className="lit-btn lit-btn--small bg-primary"
																	onClick={() =>
																		this.handleEditTestResultOverview(
																			id
																		)
																	}
																	style={{
																		height: '37px',
																	}}
																>
																	{
																		<img
																			src={
																				create
																			}
																			alt=""
																		/>
																	}
																</button>
																<button
																	className="lit-btn lit-btn--small bg-ternary"
																	style={{
																		height: '37px',
																		backgroundColor:
																			'#ed7373',
																	}}
																	onClick={() =>
																		this.handleSubTestDelete(
																			id
																		)
																	}
																>
																	<FontAwesomeIcon
																		size="lg"
																		className="lit-mytests-header-mytest-icon-btn-icon"
																		icon={
																			faTrash
																		}
																	/>
																</button>
															</td>
														</>
													</tr>
												);
											}
										)}
									</tbody>
								</table>
								{isEditTestResultOverviewButtonClicked && (
									<EditTestResultOverview
										onConfirm={
											this
												.onEditTestResultOverviewModelConfirm
										}
										onCancel={
											this
												.onEditTestResultOverviewModelConfirm
										}
										selectedTestUser={months}
										getTestsBySearch={
											this.handleSubmitTestKey
										}
										selectedId={selectedIdObject}
									/>
								)}

								{isTransferSubTestButtonClicked && (
									<TransferSubTestModel
										onEditModelConfirm={
											this.onTransferSubTestModelConfirm
										}
										onEditModelCancel={
											this.onTransferSubTestModelConfirm
										}
										getTestsBySearch={
											this.handleSubmitTestKey
										}
										selectedIds={selectedIds}
									/>
								)}
								{isSubTestDeleteButtonClicked && (
									<DeleteSubTestModel
										onDeleteModelConfirm={
											this.onSubTestDeleteModelConfirm
										}
										onDeleteModelCancel={
											this.onSubTestDeleteModelConfirm
										}
										getTestsBySearch={
											this.handleSubmitTestKey
										}
										selectedId={selectedIdObject}
										selectedTestUser={months}
									/>
								)}
								{isMarkTestButtonClicked && (
									<MarkTestConfirmation
										onMarkTestModelConfirm={
											this.onMarkTestModelConfirm
										}
										onMarkTestModelCancel={
											this.onMarkTestModelConfirm
										}
										getTestsBySearch={
											this.handleSubmitTestKey
										}
										selectedTestUser={months}
										markTest={isTestCompleted ? 0 : 1}
									/>
								)}
							</div>
						)}
					</>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SearchByTestKey);
